module.exports = __webpack_public_path__ + "static/media/maximize-incentives-icon.89d9b826.svg";